// BusSeatSvgBooking.jsx
import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";

/* ---------- SVG Components ---------- */

// Upright seat SVG
// const SeatSVG = ({ size = 40, fill = "#e0f7e9", stroke = "#019c36", label = "" }) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={label}>
//         <rect x="4" y="3" width="16" height="13" rx="2" fill={fill} stroke={stroke} strokeWidth="1" />
//         <rect x="7" y="16" width="3" height="4" rx="0.5" fill={stroke} />
//         <rect x="14" y="16" width="3" height="4" rx="0.5" fill={stroke} />
//     </svg>
// );

// Vertical berth SVG (taller and narrower)
const BerthSVG = ({ width = 30, height = 50, fill = "#e0f7e9", stroke = "#019c36", label = "" }) => (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label}>
        <rect x="1" y="1" width={width - 2} height={height - 2} rx="3" fill={fill} stroke={stroke} strokeWidth="1" />
    </svg>
);

// Small overlay icons
const MaleIcon = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
        <circle cx="12" cy="8" r="3" fill="#b71c1c" />
        <rect x="10.5" y="11" width="3" height="7" fill="#b71c1c" />
    </svg>
);

const FemaleIcon = ({ size = 12 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
        <circle cx="12" cy="7.5" r="3" fill="#1565c0" />
        <path d="M9 12h6l-1.5 6h-3z" fill="#1565c0" />
    </svg>
);

/* ---------- Main Component ---------- */

const BusUpperSeatSvg = ({ seatLayoutCount, seatMappingDetails, setBookedSeat }) => {
    const [leftSeat, setLeftSeat] = useState([])
    const [rightSeat, setRightSeat] = useState([])

    // const [seats, setSeats] = useState([
    //     { id: "400", type: "berth", status: "available" },
    //     { id: "600", type: "berth", status: "availableFemale" },
    //     { id: "500", type: "berth", status: "bookedFemale" },
    //     { id: "400", type: "berth", status: "available" },
    //     { id: "700", type: "seat", status: "available" },
    //     { id: "700", type: "seat", status: "bookedMale" },
    //     { id: "700", type: "seat", status: "bookedFemale" },
    //     { id: "700", type: "seat", status: "available" },
    //     { id: "700", type: "seat", status: "available" },
    //     { id: "700", type: "seat", status: "bookedMale" },
    //     { id: "700", type: "seat", status: "bookedFemale" },
    //     { id: "700", type: "seat", status: "available" },
    // ]);

    // const toggleSelect = (id) => {
    //     setSeats((prev) =>
    //         prev.map((s) => {
    //             if (s.id !== id) return s;
    //             if (s.status === "available") return { ...s, status: "selected" };
    //             if (s.status === "selected") return { ...s, status: "available" };
    //             return s;
    //         })
    //     );
    // };

    const colors = {
        available: { fill: "#ffffff", stroke: "#019c36a6" },
        bookedMale: { fill: "#ffebee", stroke: "#ff24bdb0" },
        bookedFemale: { fill: "#e8f4ff", stroke: "#0d99ffb0" },
        selected: { fill: "#019c36a6", stroke: "#019c36a6" },
        availableFemale: { fill: "#ffffff", stroke: "#ff24bd" },
        blocked: { fill: "#019c36a6", stroke: "#019c36a6" },
    };

    // const berthSeats = seats.filter((s) => s.type === "berth");
    // const uprightSeats = seats.filter((s) => s.type === "seat");


    const leftSideMapping = (seatLayoutCount, seatMappingDetail) => {
        let seats = [];
        if (seatLayoutCount?.lower_deck_row_count === 3) {
            if (seatLayoutCount?.upper_single_berth_count !== 0) {
                Array.from({ length: seatLayoutCount?.upper_single_berth_count }).forEach(
                    (_, i) => {
                        const e = { seatnumber: `G${i + 1}` }; // +1 so it starts from C1
                        seats.push(e);
                    }
                );
            }
            const mergedSeats = seats.map((seat) => {
                const match = seatMappingDetail.find((map) => map.seat_number === seat.seatnumber);
                return {
                    ...seat,
                    ...(match || {})
                };
            });

            setLeftSeat(mergedSeats)
        }
    }


    const rightSideMapping = (seatLayoutCount, seatMappingDetail) => {
        let seats = [];
        if (seatLayoutCount?.upper_deck_row_count === 3) {
            if (seatLayoutCount?.upper_double_berth_count !== 0) {
                const seatLetters = ['E', 'F'];
                for (var i = 0; i < seatLetters.length; i++) {
                    for (var j = 0; j < seatLayoutCount?.upper_deck_column_count; j++) {
                        const e = { seatnumber: `${seatLetters[i]}${j + 1}` };
                        seats.push(e);
                    }

                }
                const mergedSeats = seats.map((seat) => {
                    const match = seatMappingDetail.find((map) => map.seat_number === seat.seatnumber);
                    return {
                        ...seat,
                        ...(match || {})
                    };
                });

                setRightSeat(mergedSeats)

            }

        }
    }

    useEffect(() => {

        leftSideMapping(seatLayoutCount, seatMappingDetails);
        rightSideMapping(seatLayoutCount, seatMappingDetails);
    }, [seatLayoutCount, seatMappingDetails])



    const toggleRighttSide = (id) => {
        setRightSeat((prev) =>
            prev.map((s) => {
                if (s.seat_number !== id) return s;
                if (s.booking_status === "seat available") {
                    s = { seat_type: 'upper', ...s }
                    setBookedSeat((prev) => [...prev, s]);
                    return { ...s, booking_status: "selected" }
                };
                if (s.booking_status === "selected") {
                    setBookedSeat((prev) => prev.filter((item) => item !== s));
                    return { ...s, booking_status: "seat available" }
                };
                return s;
            })
        )
    }


    const toggleLeftSide = (id) => {
        setLeftSeat((prev) =>
            prev.map((s) => {
                if (s.seat_number !== id) return s;
                if (s.booking_status === "seat available") {
                    s = { seat_type: 'upper', ...s }
                    setBookedSeat((prev) => [...prev, s]);
                    return { ...s, booking_status: "selected" }
                };
                if (s.booking_status === "selected") {
                    setBookedSeat((prev) => prev.filter((item) => item !== s.seat_number));
                    return { ...s, booking_status: "seat available" }
                };
                return s;
            })
        )
    }


    return (
        <Box>
            <Grid container spacing={2}>
                {/* Left: Berths */}
                <Grid size={{ md: 6, xs: 6 }}>
                    <Grid container spacing={1}>
                        {leftSeat.map((seat) => {
                            const isClickable = seat.booking_status === "seat available" || seat.booking_status === "selected";
                            const c = colors[seat.booking_status] || colors.available;
                            return (
                                <Grid size={{ md: 12, xs: 12 }} key={seat.seat_number}>
                                    <Box
                                        onClick={() => (isClickable ? toggleLeftSide(seat.seat_number) : null)}
                                        sx={{ cursor: isClickable ? "pointer" : "default", display: "flex", alignItems: "center", gap: 0.5 }}
                                    >
                                        <Box sx={{ position: "relative", display: "inline-block" }}>
                                            <BerthSVG width={40} height={97} fill={c.fill} stroke={c.stroke} label={`${seat.seat_number} - ${seat.booking_status}`} />
                                            {(seat.status === "bookedMale" || seat.status === "bookedFemale") && (
                                                <Box sx={{ position: "absolute", top: -9, right: -8 }}>
                                                    {seat.status === "bookedMale" ? <MaleIcon /> : <FemaleIcon />}
                                                </Box>
                                            )}
                                        </Box>

                                    </Box>
                                    <Typography
                                        sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            color: "#0e182b",
                                            marginLeft: '0',
                                        }}
                                    >
                                        {"\u20B9"}{seat.basic_fare}
                                    </Typography>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>

                {/* Right: Upright seats 2 per row */}
                <Grid size={{ md: 6, xs: 6 }}>
                    <Grid container spacing={1}>
                        {rightSeat.map((seat) => {
                            const isClickable = seat.booking_status === "seat available" || seat.booking_status === "selected";
                            const c = colors[seat.booking_status] || colors.available;
                            return (
                                <Grid size={{ md: 6, xs: 6 }} key={seat.seat_number}>
                                    <Box
                                        onClick={() => (isClickable ? toggleRighttSide(seat.seat_number) : null)}
                                        sx={{ cursor: isClickable ? "pointer" : "default", display: "flex", flexDirection: "column", alignItems: "center", }}
                                    >
                                        <Box sx={{ position: "relative" }}>
                                            <BerthSVG height={97} width={40} fill={c.fill} stroke={c.stroke} label={`${seat.seat_number} - ${seat.booking_status}`} />
                                            {(seat.status === "bookedMale" || seat.status === "bookedFemale") && (
                                                <Box sx={{ position: "absolute", top: -6, right: -3 }}>
                                                    {seat.status === "bookedMale" ? <MaleIcon /> : <FemaleIcon />}
                                                </Box>
                                            )}
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                color: "#0e182b",
                                            }}
                                        >
                                            {"\u20B9"}{seat.basic_fare}
                                        </Typography>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BusUpperSeatSvg;
